import { render } from "./DoctorQueue.vue?vue&type=template&id=d5146b6e&scoped=true&ts=true"
import script from "./DoctorQueue.vue?vue&type=script&lang=ts"
export * from "./DoctorQueue.vue?vue&type=script&lang=ts"

import "./DoctorQueue.vue?vue&type=style&index=0&id=d5146b6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kmccullough\\Source\\Repos\\CPHub\\DoctorQueue.FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5146b6e"]])

export default __exports__